import { Component, Inject, Input, OnInit, Output, EventEmitter, OnChanges, SimpleChanges } from "@angular/core";
import { FormBuilder, FormGroup, UntypedFormGroup, Validators } from "@angular/forms";
import { Capitales, ICamposCapitalesRes, IGetCapitalesProm } from "@p-p-portafolio/promociones/interfaces/capitales";
import { SwalService } from "@shared/utils/swal.service";
import { ControlsService } from "@shared/services/controls/controls.service";
import { CapitalesService } from "@p-p-portafolio/promociones/services/capitales.service";

@Component({
    selector: "app-capitales-form",
    templateUrl: "./capitales-form.component.html",
    styleUrls: ["./capitales-form.component.css"],
})
export class CapitalesFormComponent implements OnChanges {
    @Input() promocion;
    @Input() dataEdit;
    @Output() onClose = new EventEmitter();

    title: "Nuevo" | "Editar" = "Nuevo";
    form: FormGroup;

    capitales = [];
    intereses = [];

    screenId: number = 9;

    constructor(
        public capitalesService: CapitalesService,
        private controlService: ControlsService,
        private swalService: SwalService,
        private fb: FormBuilder
    ) {
        this.form = this.fb.group({
            capital: [null, Validators.required],
            intereses: [null],
        });

        this.getCatalogs();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes["dataEdit"]) {
            console.log("dataEdit", this.dataEdit);
            this.getCatalogs(this.dataEdit);
        }
    }

    getCatalogs(data?: any) {
        const payload: ICamposCapitalesRes = {
            tabla: "conceptos",
            campos: "descripcion,concepto",
            where: "",
            pipe: 0,
            usuario: "",
            idioma: 0,
        };
        this.capitalesService.getCatalogDropdownCapitales(payload).subscribe({
            next: (res) => {
                for (var item of res) {
                    this.capitales.push(item);
                    this.intereses.push(item);
                }
                if (data) {
                    console.log("data", data);
                    const capitalEncontrado = this.capitales.find((item) => item.concepto == data.concepto);
                    if (capitalEncontrado) {
                        this.form.controls["capital"].setValue(capitalEncontrado.concepto);
                    }

                    const interesEncontrado = this.intereses.find((item) => item.concepto == data.conceptoInteres);
                    if (interesEncontrado) {
                        this.form.controls["intereses"].setValue(interesEncontrado.concepto);
                    }

                    this.title = "Editar";
                }
            },
            error: (err) => {
                console.log(err);
            },
        });
    }

    onSubmit() {
        console.log(this.title)
        if (this.title === "Nuevo") {
            this.add();
        } else {
            this.update();
        }
    }

    add() {
        const payload: IGetCapitalesProm = {
            sUsuario: sessionStorage.getItem("Usser"),
            sPromocion: this.promocion,
            iAccion: 0,
            iConcepto: this.form.controls["capital"].value,
            iConceptoInteres: this.form.controls["intereses"].value || 0,
        };
        this.capitalesService.add(payload).subscribe({
            next: (res) => {
                if (res) {
                    this.swalService.success("El capital se ha añadido correctamente");
                    this.form.reset();
                    this.close();
                } else {
                    this.swalService.error(res.errors[0]);
                }
            },
            error: (error) => {
                this.swalService.error(error);
            },
        });
    }

    update() {
        const payloadUpd: IGetCapitalesProm = {
            sUsuario: JSON.parse(sessionStorage.getItem("user")),
            sPromocion: this.promocion,
            iAccion: 1,
            iConcepto: this.form.controls["capital"].value,
            iConceptoInteres: this.form.controls["intereses"].value || 0,
        };

        this.capitalesService.update(payloadUpd).subscribe(
            (res) => {
                if (res) {
                    this.swalService.success("El capital se ha actualizado correctamente");
                    this.form.reset();
                    this.close();
                } else {
                    this.swalService.error(res.errors[0]);
                }
            },
            (error) => {
                this.swalService.error(error);
            }
        );
    }

    close() {
        this.onClose.emit("");
        this.form.reset();
    }
}
